import React from 'react';
import { Link } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';
import '../styles/TerminosServicio.css';

const TerminosServicio = () => {
  const userIsAuthenticated = isAuthenticated();

  return (
    <div className="terminos-container">
      <div className="terminos-card">
        <div className="terminos-header">
          <img 
            src="/sinteligen4.png" 
            alt="KleverBotBase" 
            className="terminos-logo"
          />
          <h1>Términos y Condiciones del Servicio</h1>
          <p className="terminos-fecha">Última actualización: 10 de septiembre de 2026</p>
        </div>

        <div className="terminos-content">
          <section>
            <h2>1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar la plataforma <strong>KleverBotBase</strong> (en adelante, "la Plataforma"), operada por <strong>Sinteligen</strong>, aceptas cumplir con estos Términos y Condiciones. Si no estás de acuerdo con alguna parte de estos términos, no debes usar la Plataforma.
            </p>
          </section>

          <section>
            <h2>2. Descripción del Servicio</h2>
            <p>
              KleverBotBase es una plataforma SaaS que permite a los negocios automatizar la atención al cliente y la gestión de citas a través de un asistente virtual inteligente en WhatsApp. El servicio incluye la conexión de números de WhatsApp Business, la carga de documentos para entrenamiento del bot, y la gestión de conversaciones con clientes finales.
            </p>
          </section>

          <section>
            <h2>3. Registro y Cuentas</h2>
            <p>
              Para usar la Plataforma, debes crear una cuenta proporcionando información veraz y actualizada. Eres responsable de mantener la confidencialidad de tus credenciales y de todas las actividades que ocurran en tu cuenta. Nos reservamos el derecho de suspender cuentas que incumplan estos términos.
            </p>
          </section>

          <section>
            <h2>4. Uso Aceptable</h2>
            <p>Te comprometes a no utilizar la Plataforma para:</p>
            <ul>
              <li>Enviar spam, mensajes no solicitados o contenido engañoso.</li>
              <li>Violar las políticas de uso de WhatsApp Business o de Meta.</li>
              <li>Realizar actividades ilegales, fraudulentas o que infrinjan derechos de terceros.</li>
              <li>Distribuir malware o cualquier código dañino.</li>
            </ul>
          </section>

          <section>
            <h2>5. Propiedad Intelectual</h2>
            <p>
              Todos los derechos de propiedad intelectual sobre la Plataforma, incluyendo software, diseño, logotipos y contenido, son propiedad de Sinteligen o sus licenciantes. No puedes copiar, modificar, distribuir ni crear obras derivadas sin autorización expresa.
            </p>
          </section>

          <section>
            <h2>6. Protección de Datos</h2>
            <p>
              El tratamiento de tus datos personales se rige por nuestra <Link to="/politica-privacidad" className="terminos-link">Política de Privacidad</Link>. Al usar la Plataforma, aceptas dicho tratamiento y garantizas que tienes las autorizaciones necesarias para compartir los datos de tus clientes con nosotros.
            </p>
          </section>

          <section>
            <h2>7. Limitación de Responsabilidad</h2>
            <p>
              La Plataforma se proporciona "tal cual". No garantizamos que el servicio sea ininterrumpido o libre de errores. En la medida permitida por la ley, no seremos responsables de daños indirectos, incidentales o consecuentes derivados del uso de la Plataforma.
            </p>
          </section>

          <section>
            <h2>8. Modificaciones</h2>
            <p>
              Nos reservamos el derecho de modificar estos Términos en cualquier momento. Las modificaciones entrarán en vigor al publicarse en esta página. Es tu responsabilidad revisar periódicamente los Términos actualizados.
            </p>
          </section>

          <section>
            <h2>9. Terminación</h2>
            <p>
              Podemos suspender o cancelar tu acceso a la Plataforma si incumples estos Términos o las políticas de Meta. Puedes cancelar tu cuenta en cualquier momento contactándonos.
            </p>
          </section>

          <section>
            <h2>10. Ley Aplicable y Contacto</h2>
            <p>
              Estos Términos se rigen por las leyes de Ecuador. Para cualquier consulta, puedes contactarnos en:
            </p>
            <ul>
              <li><strong>Correo electrónico:</strong> <a href="mailto:klever_mix@hotmail.com">klever_mix@hotmail.com</a></li>
              <li><strong>Plataforma:</strong> <a href="https://crm.sinteligen.com" target="_blank" rel="noopener noreferrer">https://crm.sinteligen.com</a></li>
            </ul>
          </section>
        </div>

        <div className="terminos-footer">
          <Link 
            to={userIsAuthenticated ? "/dashboard" : "/login"} 
            className="terminos-back-btn"
          >
            {userIsAuthenticated ? "← Volver al Dashboard" : "← Volver al Login"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TerminosServicio;